/* cali 2026-09-30 landing: connect the page to the live Bag Builder and cart. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cali-lp]');
  if (!root) return;

  var configs = Object.create(null);
  var configRequests = Object.create(null);
  var activeHandle = readInitialHandle();
  var mountedHandle = null;
  var bundleLoaded = false;
  var bundleRequest = null;
  var bundleScript = null;
  var returnContext = null;
  var dialogWasOpen = false;
  var pendingRemount = false;
  var remounting = false;
  var builderOpening = false;
  var cartEditPending = false;
  var stringsApplied = false;
  var statusId = 'cali-lp-runtime-status';
  var loadingId = 'cali-lp-runtime-loading';

  function rootPath() {
    var configUrl = root.getAttribute('data-config-url') || '';
    try {
      var path = new URL(configUrl, window.location.href).pathname;
      return path.replace(/\/products\/[^/]+\/?$/, '').replace(/\/$/, '');
    } catch (e) {
      return '';
    }
  }

  function storefrontPath(path) {
    return rootPath() + '/' + String(path || '').replace(/^\/+/, '');
  }

  function configUrl(handle) {
    return storefrontPath('products/' + encodeURIComponent(handle) + '?view=builderconfig');
  }

  function readInitialHandle() {
    var configured = root.getAttribute('data-builder-handle');
    if (configured) return configured;
    try {
      var path = new URL(root.getAttribute('data-config-url'), window.location.href).pathname;
      var match = path.match(/\/products\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : 'modular-sling-bag';
    } catch (e) {
      return 'modular-sling-bag';
    }
  }

  function readJson(response, label) {
    if (!response.ok) throw new Error(label + ' request failed (' + response.status + ').');
    return response.json();
  }

  function track(eventName, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName, lpHandle: root.getAttribute('data-page-handle') }, payload || {}));
    } catch (e) { /* Analytics must not block the page flow. */ }
  }

  function fetchConfig(handle) {
    handle = handle || activeHandle;
    if (configs[handle]) return Promise.resolve(configs[handle]);
    if (configRequests[handle]) return configRequests[handle];

    configRequests[handle] = fetch(configUrl(handle), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Builder configuration request failed (' + response.status + ').');
        return response.text();
      })
      .then(function (text) {
        var config;
        try { config = JSON.parse(text); } catch (e) { throw new Error('Builder configuration could not be read.'); }
        if (!config || config.ok !== true || config.handle !== handle || !Array.isArray(config.customizeProducts) || !config.customizeProducts.length) {
          throw new Error('Builder configuration is unavailable for this bag size.');
        }
        configs[handle] = config;
        return config;
      })
      .catch(function (error) {
        configRequests[handle] = null;
        throw error;
      });
    return configRequests[handle];
  }

  function applyStrings() {
    if (stringsApplied) return;
    stringsApplied = true;
    var template = document.querySelector('template[data-cali-builder-strings]');
    if (!template || !template.content) return;
    template.content.querySelectorAll('script').forEach(function (original) {
      var script = document.createElement('script');
      script.text = original.textContent;
      document.head.appendChild(script);
    });
  }

  function applyGlobals(config) {
    window.customizeProducts = config.customizeProducts;
    window.product_virtual_variant_id = config.virtualVariantId || '';
    window.presaleData = config.presaleData || {};
    window.currency = config.currency;
    window.completionTitle = config.completionTitle;
    window.soldoutTitle = config.soldoutTitle;
    window.completionBenefit1 = config.completionBenefit1;
    window.completionBenefit2 = config.completionBenefit2;
    window.completionBenefit3 = config.completionBenefit3;
    window.completionImageIcon1 = config.completionImageIcon1;
    window.completionImageIcon2 = config.completionImageIcon2;
    window.completionImageIcon3 = config.completionImageIcon3;
    window.featured_image = config.featuredImage;
    window.featured_product_url = config.featuredProductUrl;
    window.bundle_design_id = config.bundleDesignId || '';
    window.__standaloneBySku = config.standaloneBySku || {};
    window.isBundleMapping = false;
    window.__bundlePrefetchHandle = config.handle;
    var extraStrapOffer = window.__caliExtraStrapOffer;
    if (extraStrapOffer && extraStrapOffer.version === 1) {
      if (config.handle === 'modular-sling-bag') extraStrapOffer.size = 'medium';
      else if (config.handle === 'large-sling-builder') extraStrapOffer.size = 'large';
    }
  }

  function ensureMount(config) {
    var mount = document.getElementById('react-customization-app');
    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'react-customization-app';
      mount.className = 'cali-lp-builder-mount';
      document.body.appendChild(mount);
    }
    mount.setAttribute('data-product-id', config.productId || '');
    mount.setAttribute('data-product-handle', config.handle || '');
    return mount;
  }

  function loadStylesheet() {
    var href = root.getAttribute('data-style-src');
    if (!href) return Promise.reject(new Error('Builder styles are not configured.'));
    var absoluteHref = new URL(href, window.location.href).href;
    var existing = Array.prototype.find.call(document.querySelectorAll('link[rel="stylesheet"]'), function (link) {
      try { return new URL(link.href, window.location.href).href === absoluteHref; } catch (e) { return false; }
    });
    if (existing && (existing.sheet || existing.dataset.caliLpLoaded === 'true')) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      var link = existing || document.createElement('link');
      var timeout = window.setTimeout(function () {
        cleanup();
        link.remove();
        reject(new Error('Builder styles took too long to load.'));
      }, 15000);
      function cleanup() {
        window.clearTimeout(timeout);
        link.removeEventListener('load', onLoad);
        link.removeEventListener('error', onError);
      }
      function onLoad() { cleanup(); link.dataset.caliLpLoaded = 'true'; resolve(); }
      function onError() { cleanup(); link.remove(); reject(new Error('Builder styles failed to load.')); }
      link.addEventListener('load', onLoad, { once: true });
      link.addEventListener('error', onError, { once: true });
      if (!existing) {
        link.rel = 'stylesheet';
        link.href = href;
        link.dataset.caliLpStylesheet = 'true';
        document.head.appendChild(link);
      }
    });
  }

  function preloadBundleData(config) {
    if (window.__bundlePrefetch && window.__bundlePrefetchHandle === config.handle) return;
    window.__bundlePrefetchHandle = config.handle;
    window.__bundlePrefetch = fetch(storefrontPath('apps/bundle-api/bundle?handle=' + encodeURIComponent(config.handle)), {
      cache: 'no-store',
      credentials: 'same-origin'
    });
    window.__bundlePrefetch.catch(function () {});
  }

  function waitForBuilder() {
    return new Promise(function (resolve, reject) {
      var attempts = 0;
      (function check() {
        if (typeof window.caliBuilderOpen === 'function') return resolve();
        if (++attempts > 60) return reject(new Error('The builder did not finish initializing.'));
        window.setTimeout(check, 100);
      })();
    });
  }

  function loadBundle(config) {
    if (bundleLoaded && typeof window.caliBuilderOpen === 'function') return Promise.resolve();
    if (bundleRequest) return bundleRequest;
    var src = root.getAttribute('data-bundle-src');
    if (!src) return Promise.reject(new Error('Builder code is not configured.'));

    preloadBundleData(config);
    bundleRequest = loadStylesheet().then(function () {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        var timeout = window.setTimeout(function () {
          script.remove();
          if (bundleScript === script) bundleScript = null;
          reject(new Error('Builder code took too long to load.'));
        }, 30000);
        bundleScript = script;
        script.src = src;
        script.async = true;
        script.onload = function () { window.clearTimeout(timeout); bundleLoaded = true; resolve(); };
        script.onerror = function () {
          window.clearTimeout(timeout);
          script.remove();
          if (bundleScript === script) bundleScript = null;
          reject(new Error('Builder code failed to load.'));
        };
        document.head.appendChild(script);
      });
    }).then(waitForBuilder).then(function () {
      installSizeSwitch();
      mountedHandle = config.handle;
    }).catch(function (error) {
      if (bundleScript) bundleScript.remove();
      bundleScript = null;
      bundleLoaded = false;
      bundleRequest = null;
      throw error;
    });
    return bundleRequest;
  }

  function showLoading(text) {
    var overlay = document.getElementById(loadingId);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = loadingId;
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:24px;background:rgba(255,255,255,.78);font:14px/1.45 system-ui,sans-serif;color:#171717';
      var label = document.createElement('span');
      label.setAttribute('data-cali-lp-loading-label', '');
      label.style.cssText = 'padding:16px 20px;background:#fff;border:1px solid #deded8;box-shadow:0 8px 30px rgba(0,0,0,.1)';
      overlay.appendChild(label);
      document.body.appendChild(overlay);
    }
    var loadingLabel = overlay.querySelector('[data-cali-lp-loading-label]');
    if (loadingLabel) loadingLabel.textContent = text;
    overlay.hidden = false;
    overlay.style.display = 'grid';
  }

  function hideLoading() {
    var overlay = document.getElementById(loadingId);
    if (overlay) {
      overlay.hidden = true;
      overlay.style.display = 'none';
    }
  }

  function showError(text) {
    hideLoading();
    var status = document.getElementById(statusId);
    if (!status) {
      status = document.createElement('div');
      status.id = statusId;
      status.setAttribute('role', 'alert');
      status.style.cssText = 'position:fixed;z-index:2147483001;left:16px;right:16px;bottom:16px;max-width:560px;margin:auto;padding:14px 18px;background:#fff;border:1px solid #b42318;color:#6f1d16;box-shadow:0 4px 24px rgba(0,0,0,.13);font:14px/1.45 system-ui,sans-serif';
      document.body.appendChild(status);
    }
    status.textContent = text;
    status.hidden = false;
  }

  function clearError() {
    var status = document.getElementById(statusId);
    if (status) status.hidden = true;
  }

  function builderDialogOpen() {
    return Array.prototype.some.call(document.querySelectorAll('[role="dialog"].customizer-dialog-content'), function (dialog) {
      return dialog.getAttribute('data-state') !== 'closed' && dialog.getAttribute('aria-hidden') !== 'true';
    });
  }

  function cartDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');
    return !!(drawer && drawer.classList.contains('drawer--is-open'));
  }

  function focusWithoutScroll(element) {
    if (!element || !element.isConnected || typeof element.focus !== 'function') return;
    try { element.focus({ preventScroll: true }); } catch (e) { element.focus(); }
  }

  function restoreReturnContext() {
    var context = returnContext;
    if (!context || cartDrawerOpen() || builderDialogOpen() || builderOpening || remounting || pendingRemount) return;
    // Preset/edit/swap parameters are temporary builder inputs. Drop them only
    // after the dialog closes, keeping unrelated query parameters and the hash.
    replaceQuery({});
    returnContext = null;
    window.scrollTo(0, context.scrollY);
    focusWithoutScroll(context.trigger);
  }

  function observeBuilderClose() {
    if (!document.body || !window.MutationObserver) return;
    function check() {
      if (builderDialogOpen()) {
        dialogWasOpen = true;
        hideLoading();
        clearError();
        return;
      }
      if (!dialogWasOpen) return;
      dialogWasOpen = false;
      if (pendingRemount) return;
      window.setTimeout(function () {
        restoreReturnContext();
      }, 340);
    }
    new MutationObserver(check).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-state', 'aria-hidden']
    });
    check();
  }

  function saveReturnContext(trigger) {
    returnContext = {
      trigger: trigger || null,
      scrollY: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    };
  }

  function openBuilder(trigger, handle) {
    if (remounting || builderOpening) return;
    var button = trigger && trigger.nodeType === 1 ? trigger : null;
    handle = handle || (button && button.getAttribute('data-builder-handle')) || activeHandle;
    var designId = button && button.getAttribute('data-cali-lp-design-id');
    if (!returnContext || (!dialogWasOpen && !cartDrawerOpen())) saveReturnContext(trigger);
    var where = (button && button.getAttribute('data-cali-lp-build')) || 'cta';
    track('cali_lp_build_click', { where: where, builderHandle: handle, designId: designId || undefined });
    if (designId && bundleLoaded) {
      remountBuilder({ mode: 'preset', handle: handle, designId: designId });
      return;
    }
    if (bundleLoaded && mountedHandle && mountedHandle !== handle) {
      remountBuilder({ mode: 'swap', handle: handle, pre: [] });
      return;
    }
    replaceQuery(designId ? { designId: designId } : {});
    builderOpening = true;
    if (button) button.setAttribute('aria-busy', 'true');
    clearError();
    showLoading('Opening your bag builder…');

    fetchConfig(handle).then(function (config) {
      activeHandle = config.handle;
      root.setAttribute('data-builder-handle', activeHandle);
      window.caliBuilderInit = {
        startStep: 0,
        startingPoint: designId ? 'landing:' + (root.getAttribute('data-page-handle') || 'sling-v2') + ':preset:' + designId : 'landing:' + (root.getAttribute('data-page-handle') || 'sling-v2') + ':' + where,
        source: 'landing'
      };
      if (bundleLoaded && typeof window.caliBuilderOpen === 'function') {
        applyGlobals(config);
        window.caliBuilderOpen(window.caliBuilderInit);
        return null;
      }
      applyStrings();
      applyGlobals(config);
      ensureMount(config);
      return loadBundle(config).then(function () { mountedHandle = config.handle; });
    }).then(function () {
      if (button) button.removeAttribute('aria-busy');
      document.documentElement.classList.add('cali-lp-builder-used');
      if (builderDialogOpen()) hideLoading();
      clearError();
    }).catch(function (error) {
      if (button) button.removeAttribute('aria-busy');
      track('cali_lp_build_error', { reason: String((error && error.message) || error) });
      showError('The bag builder could not open. ' + (error && error.message ? error.message : 'Check your connection and try again.'));
      window.setTimeout(restoreReturnContext, 340);
    }).then(function () {
      builderOpening = false;
    });
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.setTimeout(function () {
      if (cartDrawerOpen()) return;
      var nativeTrigger = document.querySelector('.js-drawer-open-cart');
      if (nativeTrigger) nativeTrigger.click();
    }, 300);
  }

  function closeCart() {
    if (!cartDrawerOpen()) return;
    document.dispatchEvent(new CustomEvent('cart:close'));
    var closeButton = document.querySelector('#CartDrawer .js-drawer-close');
    if (closeButton) closeButton.click();
  }

  function replaceQuery(params) {
    var url = new URL(window.location.href);
    ['build', 'pre', 'designId', 'editBid', 'editExtra'].forEach(function (key) { url.searchParams.delete(key); });
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') url.searchParams.set(key, String(params[key]));
    });
    window.history.replaceState(window.history.state || {}, '', url.pathname + url.search + url.hash);
  }

  function closeBuilder() {
    if (!builderDialogOpen()) return;
    var closeButton = document.querySelector('[role="dialog"].customizer-dialog-content .mobile-close-button, [role="dialog"].customizer-dialog-content .close-button');
    if (closeButton) closeButton.click();
  }

  function remountBuilder(request) {
    if (!request || !['modular-sling-bag', 'large-sling-builder'].includes(request.handle) || remounting) return;
    remounting = true;
    pendingRemount = true;
    activeHandle = request.handle;
    root.setAttribute('data-builder-handle', activeHandle);
    showLoading('Loading your bag size…');
    closeCart();
    closeBuilder();

    var attempts = 0;
    function waitUntilClosed() {
      if (builderDialogOpen() || cartDrawerOpen()) {
        if (++attempts > 100) {
          pendingRemount = false;
          remounting = false;
          showError('Close the open panel and try switching bag size again.');
          window.setTimeout(restoreReturnContext, 340);
          return;
        }
        window.setTimeout(waitUntilClosed, 50);
        return;
      }
      window.setTimeout(function () {
        if (builderDialogOpen() || cartDrawerOpen()) return waitUntilClosed();
        finishRemount(request);
      }, 360);
    }
    waitUntilClosed();
  }

  function finishRemount(request) {
    try {
      showLoading('Loading your bag size…');
      if (request.mode === 'swap') {
        var swap = window.__caliSwap;
        replaceQuery({ build: '1', pre: swap && typeof swap.encode === 'function' ? swap.encode(request.pre || []) : '' });
      } else if (request.mode === 'preset') {
        // designId opens this preset as a fresh design. editBid is only for replacing a cart line.
        replaceQuery({ designId: request.designId });
      } else {
        replaceQuery({ designId: request.designId, editBid: request.editBid, editExtra: request.editExtra ? '1' : '' });
      }

      var oldMount = document.getElementById('react-customization-app');
      if (oldMount) oldMount.remove();
      mountedHandle = null;
      if (bundleScript) bundleScript.remove();
      bundleScript = null;
      bundleLoaded = false;
      bundleRequest = null;
      window.caliBuilderOpen = null;
      window.__bundlePrefetch = null;
      window.__bundlePrefetchHandle = request.handle;
      window.__caliSwapPre = null;
      configs[request.handle] = null;
      configRequests[request.handle] = null;

      fetchConfig(request.handle).then(function (config) {
        applyStrings();
        applyGlobals(config);
        var mount = document.createElement('div');
        mount.id = 'react-customization-app';
        mount.className = 'cali-lp-builder-mount';
        mount.setAttribute('data-product-id', config.productId || '');
        mount.setAttribute('data-product-handle', config.handle || '');
        document.body.appendChild(mount);
        window.caliBuilderInit = {
          startStep: 0,
          startingPoint: 'landing:' + (root.getAttribute('data-page-handle') || 'sling-v2') + ':' + request.mode,
          source: 'landing'
        };
        return loadBundle(config);
      }).then(function () {
        mountedHandle = request.handle;
        replaceQuery({});
        document.documentElement.classList.add('cali-lp-builder-used');
        if (builderDialogOpen()) hideLoading();
        clearError();
      }).catch(function (error) {
        track('cali_lp_build_error', { reason: String((error && error.message) || error), builderHandle: request.handle });
        showError('The bag builder could not switch sizes. ' + (error && error.message ? error.message : 'Check your connection and try again.'));
        window.setTimeout(restoreReturnContext, 340);
      }).then(function () {
        pendingRemount = false;
        remounting = false;
      });
    } catch (error) {
      pendingRemount = false;
      remounting = false;
      track('cali_lp_build_error', { reason: String((error && error.message) || error), builderHandle: request.handle });
      showError('The bag builder could not switch sizes. ' + (error && error.message ? error.message : 'Please try again.'));
      window.setTimeout(restoreReturnContext, 340);
    }
  }

  function installSizeSwitch() {
    var swap = window.__caliSwap;
    if (!swap || typeof swap.carry !== 'function' || typeof swap.encode !== 'function') return;
    swap.go = function (source, target) {
      if (!target || !['modular-sling-bag', 'large-sling-builder'].includes(target.to)) return;
      var visible = [];
      try { visible = source && typeof source.visible === 'function' ? source.visible() || [] : []; } catch (e) { visible = []; }
      var carried = swap.carry(visible);
      if (typeof window.__caliTrack === 'function') {
        window.__caliTrack('size_swap', { from: source && source.handle || activeHandle, to: target.to, carried: carried.length });
      }
      remountBuilder({ mode: 'swap', handle: target.to, pre: carried });
    };
  }

  function editCartItem(link) {
    if (cartEditPending) return true;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;
    var match = url.pathname.match(/\/products\/([^/]+)\/?$/);
    var handle = match ? decodeURIComponent(match[1]) : '';
    var designId = url.searchParams.get('designId');
    if (!['modular-sling-bag', 'large-sling-builder'].includes(handle) || !designId) return false;

    cartEditPending = true;
    link.setAttribute('aria-busy', 'true');
    fetch(storefrontPath('cart.js'), { credentials: 'same-origin' })
      .then(function (response) { return readJson(response, 'Cart'); })
      .then(function (cart) {
        var row = link.closest('.cart__item[data-key]');
        var key = row && row.getAttribute('data-key');
        var matches = (Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
          var properties = item && item.properties || {};
          return item && (!key || item.key === key) && properties._bundleType === 'master' &&
            (String(properties._designId || '') === designId || String(properties._designProductId || '') === designId);
        });
        if (matches.length !== 1 || !matches[0].properties._bid) throw new Error('This saved bag could not be matched to one cart item.');
        remountBuilder({
          mode: 'edit',
          handle: handle,
          designId: designId,
          editBid: matches[0].properties._bid,
          editExtra: url.searchParams.get('editExtra') === '1'
        });
      })
      .catch(function (error) {
        showError('The saved bag could not be opened. ' + (error && error.message ? error.message : 'Please try again.'));
      })
      .then(function () {
        cartEditPending = false;
        link.removeAttribute('aria-busy');
      });
    return true;
  }

  function openEmptyCartBuilder(link) {
    var cartButton = document.querySelector('[data-cali-lp-cart]');
    saveReturnContext(cartButton || link);
    closeCart();
    openBuilder(cartButton || link, 'modular-sling-bag');
  }

  function updateCartCount() {
    fetch(storefrontPath('cart.js'), { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var count = cart.items.reduce(function (sum, item) {
          if (item && item.properties && item.properties._bundleType === 'child') return sum;
          return sum + (Number(item && item.quantity) || 0);
        }, 0);
        document.querySelectorAll('[data-cali-lp-cart-count]').forEach(function (node) {
          node.textContent = count ? String(count) : '';
          node.setAttribute('aria-label', count ? String(count) : '0');
        });
      })
      .catch(function () {});
  }

  function observeCartDrawerClose() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;
    var wasOpen = cartDrawerOpen();
    new MutationObserver(function () {
      var isOpen = cartDrawerOpen();
      if (wasOpen && !isOpen && !builderDialogOpen() && !builderOpening && !cartEditPending && !remounting && !pendingRemount) {
        window.setTimeout(restoreReturnContext, 0);
      }
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function stickyBar() {
    var bar = document.querySelector('[data-cali-lp-sticky]');
    if (!bar) return;
    var hero = document.querySelector('[data-cali-lp-hero]');
    var sizeCta = document.querySelector('[data-cali-lp-size-cta]');
    var finalCta = document.querySelector('[data-cali-lp-final-cta]');
    if (!('IntersectionObserver' in window) || !hero) return;

    var heroVisible = true;
    var sizeCtaVisible = false;
    var finalCtaVisible = false;
    function update() {
      var visible = !heroVisible && !sizeCtaVisible && !finalCtaVisible;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.querySelectorAll('a,button').forEach(function (control) { control.tabIndex = visible ? 0 : -1; });
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) heroVisible = entry.isIntersecting || entry.boundingClientRect.top >= 0;
        if (entry.target === sizeCta) sizeCtaVisible = entry.isIntersecting;
        if (entry.target === finalCta) finalCtaVisible = entry.isIntersecting;
      });
      update();
    }, { threshold: 0.05 });
    observer.observe(hero);
    if (sizeCta) observer.observe(sizeCta);
    if (finalCta) observer.observe(finalCta);
    update();
  }

  function warm() {
    fetchConfig(activeHandle).catch(function () {});
    ['data-style-src', 'data-bundle-src'].forEach(function (attribute, index) {
      var href = root.getAttribute(attribute);
      if (!href) return;
      var exists = Array.prototype.some.call(document.querySelectorAll('link[rel="preload"]'), function (link) {
        try { return new URL(link.href, window.location.href).href === new URL(href, window.location.href).href; } catch (e) { return false; }
      });
      if (exists) return;
      var link = document.createElement('link');
      link.rel = 'preload';
      link.as = index === 0 ? 'style' : 'script';
      link.href = href;
      document.head.appendChild(link);
    });
  }

  function scheduleWarm() {
    var schedule = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 4000 });
      else window.setTimeout(warm, 1500);
    };
    if (document.readyState === 'complete') window.setTimeout(schedule, 800);
    else window.addEventListener('load', function () { window.setTimeout(schedule, 800); }, { once: true });
    document.addEventListener('pointerdown', function (event) {
      if (event.target.closest && event.target.closest('[data-cali-lp-build]')) warm();
    }, { passive: true, capture: true });
  }

  function installEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      var edit = target.closest && target.closest('#CartDrawer a.cart__item--edit-design-link, #CartDrawer a[href*="designId="]');
      if (edit && editCartItem(edit)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var emptyBuild = target.closest && target.closest('#CartDrawer a[href*="/products/modular-sling-bag"][href*="build=1"]');
      if (emptyBuild) {
        event.preventDefault();
        event.stopPropagation();
        openEmptyCartBuilder(emptyBuild);
        return;
      }

      var build = target.closest && target.closest('[data-cali-lp-build]');
      if (build) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;
        event.preventDefault();
        openBuilder(build);
        return;
      }

      var cartButton = target.closest && target.closest('[data-cali-lp-cart]');
      if (cartButton) {
        event.preventDefault();
        if (!returnContext || (!dialogWasOpen && !cartDrawerOpen())) saveReturnContext(cartButton);
        openCart();
      }
    }, true);
  }

  function init() {
    installEvents();
    stickyBar();
    observeBuilderClose();
    observeCartDrawerClose();
    updateCartCount();
    ['cart:build', 'cart:updated', 'ajaxProduct:added'].forEach(function (name) {
      document.addEventListener(name, updateCartCount);
    });
    document.addEventListener('ajaxProduct:added', function () {
      // The live CartDrawer owns add-to-cart opening; refresh only the page count here.
      window.setTimeout(updateCartCount, 250);
    });
    document.addEventListener('page:loaded', installSizeSwitch);
    installSizeSwitch();
    scheduleWarm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
